import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { BaseListComponent, EvGridTableModule, ITableHeader, ITableLayoutModel } from "ev-grid-table";
import { IUnitsFilterGroupItem } from "src/app/infopage/new-dwelling/newdwelling.model";

@Component({
    selector: "floors-groups",
    imports: [CommonModule, EvGridTableModule],
    templateUrl: "./floors-groups.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloorsGroupsComponent extends BaseListComponent<IUnitsFilterGroupItem> {
    floors = input<IUnitsFilterGroupItem[]>([]);

    override originalData = computed(() => this.floors() ?? []);

    override tableData = computed(() => {
        const { sortOption } = this.sortConfig();
        const data = [...(this.originalData() ?? [])];
        if (data.length === 0) {
            return [];
        }

        const d = sortOption.desc ? 1 : -1;
        data.sort((a, b) => {
            const av = this.sortValue(a, sortOption.prop);
            const bv = this.sortValue(b, sortOption.prop);
            return av === bv ? 0 : av > bv ? -1 * d : 1 * d;
        });

        return data.slice(0, this.numberOfRowsConfig().rowsToShow);
    });

    private sortValue(row: IUnitsFilterGroupItem, prop: string): number {
        switch (prop) {
            case "total":
                return row.total?.numberOfUnits ?? 0;
            case "sold":
                return row.sold?.numberOfUnits ?? 0;
            case "unsold":
                return row.unsold?.numberOfUnits ?? 0;
            default:
                return row.groupKeyValue;
        }
    }

    protected override createHeaders(): ITableHeader[] {
        return [
            { name: "Etg", prop: "groupKeyValue", desc: false, type: "number", isSortable: true },
            { name: "Tot", prop: "total", desc: true, type: "number", isSortable: true, textAlignment: "right" },
            { name: "Solgt", prop: "sold", desc: true, type: "number", isSortable: true, textAlignment: "right" },
            { name: "Usolgt", prop: "unsold", desc: true, type: "number", isSortable: true, textAlignment: "right" },
        ];
    }

    protected override createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas: '"groupKeyValue total sold unsold"',
                    gridColumns: "1fr 40px 50px 50px",
                },
            ],
        };
    }
}
